import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { QuestionTestDialogComponent } from '../question-test-dialog/question-test-dialog.component';


@Component({
  selector: 'app-selection-test-dialog',
  templateUrl: './selection-test-dialog.component.html',
  styleUrls: ['./selection-test-dialog.component.scss']
})
export class SelectionTestDialogComponent implements OnInit {

  submiting: boolean = false;
  formTest: FormGroup;
  formQuestion: FormGroup;
  questions: Array<any> = [];
  isSmallScreen$: Observable<boolean>;
  showFormQuestion: boolean = false;
  idTest: number;

  public get Options(): FormArray {
    return this.formQuestion.get('options') as FormArray;
  }

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any,
    private http: HttpService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<SelectionTestDialogComponent>,
    private snackbar: MatSnackBar,
    private errorReport: ErrorReportService,
    private breakpoint: BreakpointObserver
  ) {

    const currentUser = JSON.parse(localStorage.getItem('token'));
    this.formTest = fb.group({
      id: [null],
      name: [null, [Validators.required, Validators.maxLength(100)]],
      description: [null],
      inUse: [null],
      companyId: [currentUser.company_id, Validators.required]
    });

    this.formQuestion = fb.group({
      id: [null],
      descriptionQuestion: [null, [Validators.required, Validators.maxLength(256)]],
      questionType: [null, Validators.required],
      required: [true, Validators.required],
      options: fb.array([])
    });

    this.addOptions();

    if (data.test) {
      const { test } = data;
      this.formTest.patchValue(test);
      this.getTestQuestions();
      this.formTest.markAsPristine();
    }

  }

  editQuestion(question) {

    // this.showFormQuestion = true;
    // this.Options.clear();

    // const { descriptionQuestion, questionType, id, required, options } = question;
    // options.forEach(option => {
    //   option.isRight = option.isRight == '1';
    //   this.addOptions();
    // });

    // this.formQuestion.patchValue({
    //   id,
    //   descriptionQuestion,
    //   questionType,
    //   required: required == '1',
    //   options
    // })

  }

  getTestQuestions() {

    let id = this.formTest.get('id').value;
    if(id == null || id == undefined){
      id = this.idTest;
    }

    this.http.get('selection_test:details', { id })
      .subscribe(
        (result: any) => {
          this.formTest.patchValue({ inUse: result.inUse });
          this.questions = [];

          for (const question of result.questions) {
            this.questions.push({
              id: question.id,
              descriptionQuestion: question.description,
              questionType: question.question_type,
              required: question.required == '1' ? true : false,
              options: question.options.map(option => ({ isRight: option.is_right == '1' ? true : false, name: option.description }))
            })
          }
        },
        err => this.errorReport.showMessage(err)
      );

  }

  addOptions(name = null, isRight = false) {
    const controls = this.formQuestion.get('options') as FormArray;
    controls.push(this.fb.group({
      name: [name, Validators.required],
      isRight: [isRight, Validators.required]
    }));
  }

  removeOption(i: number) {

    if (!confirm('Deseja realmente remover essa opção?'))
      return;

    this.Options.removeAt(i);

  }

  removeQuestion(i: number) {

    if (!confirm('Deseja realmente remover essa questão?'))
      return;

    this.questions.splice(i, 1);

  }

  ngOnInit(): void {

    this.isSmallScreen$ = this.breakpoint
      .observe([Breakpoints.XSmall, Breakpoints.HandsetPortrait])
      .pipe(
        map(state => {
          return state.matches
        })
      )

    const subject = new Subject();
    subject.subscribe(
      (result: any) => {

        const { trigger, scope } = result;
        if (scope.indexOf('selection_test') > -1)
          this.submiting = trigger === 'pre';

      }
    )
    this.http.setLoadingIndicator(subject)

    this.formQuestion.get('questionType')
      .valueChanges
      .subscribe(
        questionType => {

          const id = this.formQuestion.get('id').value;

          if (id === null) {

            this.Options.clear();
            if (questionType !== 'dissertative')
              this.addOptions();

          }

        }
      )

  }

  submit() {

    const data = {
      ...this.formTest.getRawValue(),
      questions: this.questions
    };

    if (!this.formTest.invalid) {

      let request$: Observable<any>;

      if (data.id) {
        if (data.inUse) {
          if (confirm('Não é possivel editar esse questionário ele já esta sendo usado pelos candidatos, deseja criar outro questionário com mesmo conteúdo'))
            request$ = this.http.save('selection_test', data)
          else
            request$ = this.http.save('selection_test:update', data);
        } else request$ = this.http.save('selection_test:update', data)
      } else request$ = this.http.save('selection_test', data)

      request$.subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.snackbar.open('Teste salvo com sucesso!', 'OK', { duration: 3000 });
            this.dialogRef.close(true);
          }
        },
        err => this.errorReport.showMessage(err)
      );

    }

  }

  numQuestion = 0;

  addQuestion() {
    const isValid = !this.formQuestion.invalid;

    if (isValid) {
      const data = this.formQuestion.getRawValue();

      const options = data.options;
      // Filtra as opções com isRight igual a true
      const rightOptions = options.filter(option => option.isRight);

      if (data.questionType == 'multiple') {

        if (rightOptions.length == 0) {
          this.snackbar.open('Por Favor antes de salvar escolha uma opção como correta', 'OK', { duration: 8000, panelClass: ['error-snackbar'] });
          return false;
        } else if (rightOptions.length > 1) {
          this.snackbar.open('Por Favor selecione apenas uma opção como correta antes de salvar', 'OK', { duration: 8000, panelClass: ['error-snackbar'] });
          return false;
        }

      }

      if (data.questionType == 'option') {

        if (rightOptions.length == 0) {
          this.snackbar.open('Por Favor antes de salvar escolha uma opção como correta', 'OK', { duration: 8000, panelClass: ['error-snackbar'] });
          return false;
        }

      }

      const existingQuestionIndex = this.questions.findIndex(q => q.id === data.id);

      if (existingQuestionIndex !== -1) {
        // Se a pergunta já existir, atualize-a
        this.questions[existingQuestionIndex] = data;

      } else {
        // Caso contrário, adicione como uma nova pergunta
        data.id = this.numQuestion++;
        this.questions.push(data);
      }

      this.formQuestion.reset({ required: true });
      this.formQuestion.markAsPristine();
      this.showFormQuestion = false;
    }
  }

  cancelQuestion() {

    this.formQuestion.reset({ required: true });
    this.formQuestion.markAsPristine();
    this.showFormQuestion = false;

  }

  openQuestionDialog(question: any = null) {

    const options = {
      width: '800px',
      disabledClose: true,
      data: {
        testId: this.idTest,
        question
      }
    }

    this.dialog.open(QuestionTestDialogComponent, options)
      .afterClosed()
      .subscribe((result: any) => {
        if (result) {
          // console.log('retorno TESTE', result);
          if (result === true) {
            
            this.presubmit();
            setTimeout(()=>{
              this.getTestQuestions();
            },1000)

          } else {
            // Verifica se a pergunta já existe no this.questions
            const existingQuestionIndex = this.questions.findIndex(q => q.id === result.id);

            if (existingQuestionIndex !== -1) {
              // Atualiza a pergunta existente
              this.questions[existingQuestionIndex] = result;
            } else {
              // Adiciona como uma nova pergunta
              result.id = this.numQuestion++;
              this.questions.push(result);
            }
            this.presubmit();
          }
        }
      })

  }

  presubmit() {

    const data = {
      ...this.formTest.getRawValue(),
      questions: this.questions
    };

    if (!this.formTest.invalid) {

      let request$: Observable<any>;

      request$ = this.http.save('selection_test', data)

      request$.subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.idTest = result.id;
          }
        },
        err => this.errorReport.showMessage(err)
      );

    }

  }

}
